import { IconName } from '@fortawesome/fontawesome-svg-core';
import { Params } from 'react-router-dom';
import { StepperComponent } from "../components";

export interface apps {
    idApp : number
    nombre : string
    logo : string
    /*icon : string*/
    icono : IconName
}

export interface opcs {
  idApp : number
  idOpc : number
  nombre : string
  url : string
  icon : IconName
}

export interface rol{
  idRol : number
  nombre: string
  icon: IconName
}

const menuApps: Array<apps> = [
  {idApp : 1, nombre : "Credito", logo : "", icono : "dollar-sign"},
  {idApp : 2, nombre : "Matricula", logo : "", icono : "check"},
  {idApp : 3, nombre : "Conciliaciones", logo : "", icono : "address-book"},
  {idApp : 4, nombre : "Asamblea", logo : "", icono : "coffee"},
  {idApp : 5, nombre : "Credito", logo : "", icono : "baby"},
  {idApp : 6, nombre : "Matricula", logo : "", icono : "cogs"},
  {idApp : 7, nombre : "Conciliaciones", logo : "", icono : "credit-card"},
  {idApp : 8, nombre : "Asamblea", logo : "", icono : "ambulance"}
]

const menuOpcs: Array<opcs> = [
  {idApp : 1, idOpc : 1, nombre : "Consultar listado pagos lib", url : "", icon : "dollar-sign"},
  {idApp : 1, idOpc : 2, nombre : "Consultar pagos libranzas", url : "", icon : "dollar-sign"},
  {idApp : 1, idOpc : 3, nombre : "Simulador créditos", url : "", icon : "dollar-sign"},
  {idApp : 1, idOpc : 4, nombre : "Cargar consumos cupos", url : "", icon : "dollar-sign"},
  {idApp : 2, idOpc : 5, nombre : "Consultar inscripciones", url : "", icon : "dollar-sign"},
]

const roles: Array<rol> = [
    {idRol: 1, nombre: "Empleador", icon: "industry"},
    {idRol: 2, nombre: "Trabajador", icon: "briefcase"},
    {idRol: 3, nombre: "Usuario interno", icon: "user-shield"},
    {idRol: 4, nombre: "Administrador", icon: "user-cog"}
]


export interface Idocumento {
  referencia: string;
  valorTotal: number;
  valorMinimo: number;
  detalle: string;
  vence: string;
  codigoServicio: string;
  trans_bloq: boolean;
}

export interface ServiciosVentas {
  id: string;
  nombre: string;
  abonable: boolean;
  porcentajeAbono: number;
  codigoServicio: string;
  tokenEpayco: string;
  idClienteEpayco: string;
  codigoServicioSap: string;
}

export interface TiposDocumentos {
  codigo: number;
  descripcion: string;
  abreviatura: string;
}

export interface Iservicio {
  [propName: string]: Idocumento[];
}

export interface payLoadDatosMaestros{
  setTiposDocumentosDisponibles: React.Dispatch<
  React.SetStateAction<TiposDocumentos[]>
  >,
  setPantallaBloqueada: React.Dispatch<React.SetStateAction<boolean>>,
  setServiciosVentasDisponibles: React.Dispatch<
    React.SetStateAction<ServiciosVentas[]>
  >,
  setStepIndex: React.Dispatch<React.SetStateAction<number>>,
  estado: Iestado,
  stepper: React.MutableRefObject<StepperComponent | null>,
  setEstado:React.Dispatch<React.SetStateAction<Iestado>>,
  parametrosURL: Readonly<Params<string>>,
  tiposDocumentos: TiposDocumentos[],
  serviciosVentas: ServiciosVentas[]
}

export interface payLoadEventoPagosServicios{
  event: React.ChangeEvent<HTMLSelectElement>,
  estado: Iestado,
  documentosPago: Idocumento[],
  setShowError: React.Dispatch<React.SetStateAction<boolean>>,
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>,
  setDocumentosPagoDisponibles: React.Dispatch<
    React.SetStateAction<Idocumento[]>
  >,
  setPantallaBloqueada: React.Dispatch<React.SetStateAction<boolean>>,
  setErrorMensaje: React.Dispatch<React.SetStateAction<string>>
}

export interface payLoadPagoRapido{
  idpago: string,
  estado: Iestado,
  stepper: React.MutableRefObject<StepperComponent | null>,
  serviciosVentas: Array<ServiciosVentas>,
  setPantallaBloqueada: React.Dispatch<React.SetStateAction<boolean>>,
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>,
  setStepIndex: React.Dispatch<React.SetStateAction<number>>
}

export interface detallePago{
    referencia: string;
    descrip: string;
    limite: string;
    valorTotal: number;
    valorMinimo: number;
    abonable: boolean;
    hacer_abono: boolean;
    porMinimoAbono: number;
    valorMinimoAbono: number;
    valor_abono: number;
    codigoServicio: string;
    codigoServicioSAP: string;
    idServicio: string | null;
    fechaVencimiento: string;
    tipoPago: string;
  };

/*interface Iarregloreferencia{
  [propName: string]: detallePago;
}*/

export interface Iestado {
    showError: boolean;
    showDetail: boolean;
    tipoDocumento: string;
    documento: string;
    servicio: string;
    correo: string;
    telefono: string;
    nombres: string;
    apellidos: string;
    direccion: string;
    guidTransaccion: string | null;
    tokenEpayco: string;
    idServicio: string | null;
    referenciaActiva: string;
    fechaVencimiento: string;
    referencias: {[propName: string] : detallePago}
  };

export interface respuestaWebApi{
    exito: boolean,
    mensaje: string,
    data: object | any
}

export interface respuestaEpayco{
        x_cust_id_cliente: string,
        x_ref_payco: string,
        x_id_factura: string,
        x_id_invoice: string,
        x_description: string,
        x_amount: number,
        x_amount_country: number,
        x_amount_ok: number,
        x_tax: number,
        x_tax_ico: number,
        x_amount_base: string,
        x_currency_code: string,
        x_bank_name: string,
        x_cardnumber: string,
        x_quotas: string,
        x_respuesta: string,
        x_response: string,
        x_approval_code: string,
        x_transaction_id: string,
        x_fecha_transaccion: string,
        x_transaction_date: string,
        x_cod_respuesta: string,
        x_cod_response: string,
        x_response_reason_text: string,
        x_cod_transaction_state: string,
        x_transaction_state: string,
        x_errorcode: string,
        x_franchise: string,
        x_business: string,
        x_customer_doctype: string,
        x_customer_document: string,
        x_customer_name: string,
        x_customer_lastname: string,
        x_customer_email: string,
        x_customer_phone: string,
        x_customer_movil: string,
        x_customer_ind_pais: string,
        x_customer_country: string,
        x_customer_city: string,
        x_customer_address: string,
        x_customer_ip: string,
        x_signature: string,
        x_test_request: string,
        x_extra1: string,
        x_extra2: string,
        x_extra3: string,
        x_extra4: string,
        x_extra5: string,
        x_extra6: string,
        x_extra7: string,
        x_extra8: string,
        x_extra9: string,
        x_extra10: string,
        x_type_payment: string
}

export { menuApps, menuOpcs, roles}